import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "@/context/ThemeContext";

// Silence the benign "ResizeObserver loop completed with undelivered notifications" error.
// Deferring RO callbacks one frame prevents the loop overflow; the listeners hide any stray overlay.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => { try { cb(entries, observer); } catch (_) { /* noop */ } });
      });
    }
  };
}
const _isROErr = (m) => typeof m === "string" && m.includes("ResizeObserver loop");
window.addEventListener("error", (e) => { if (_isROErr(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); } });
window.addEventListener("unhandledrejection", (e) => { if (_isROErr(String(e.reason?.message || e.reason))) e.preventDefault(); });

// Apply saved theme before first paint to avoid flash
const saved = localStorage.getItem("lm_theme") || "dark";
if (saved === "dark") document.documentElement.classList.add("dark");

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
